import React from 'react'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'

interface IBidStatusProps {
  status: string | null
}

export const BidStatus = ({ status }: IBidStatusProps) => {
  let label = ''
  const tagStyle = TAG_STYLE.dark
  // to do - build logic for other statuses once we determine how to calculate those
  if (status === null) {
    label = 'Unknown'
  }

  return <Tag size={TAG_SIZE.xsmall} tagStyle={tagStyle} label={label} />
}
